export default __webpack_public_path__ + "static/media/about.32b021f8.png";